import { put, takeLatest, call, select } from 'redux-saga/effects';
import { showLoader } from '../globalReducer';
import {
  fetchExternalContacts,
  fetchExternalContactsSuccess,
  fetchDocsReceived,
  fetchDocsReceivedSuccess,
  fetchDocsSent,
  fetchDocsSentSuccess,
  postExternalContact,
  putExternalContact,
  putSecureShareDoc,
  putExternalContactSuccess,
  putSecureShareDocSuccess,
  postExternalContactSuccess,
} from './slice';
import { toast } from 'react-toastify';
import { apiErrorHandler } from '../Utils/apiErrorHandler';
import { chrApi } from '../../api/api';

function* _fetchExternalContacts(action) {
  try {
    yield put(showLoader(true));
    const { userId, practiceId } = action.payload;
    const { data } = yield call(() => chrApi('get', `external_contact`, null, { userId, practiceId, userType: window.localStorage.getItem('__type__') }));
    yield put(fetchExternalContactsSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _fetchDocsReceived(action) {
  try {
    const { userId, practiceId } = action.payload;
    yield put(showLoader(true));
    const { data } = yield call(() => chrApi('get', 'secure_share', null, { userId, practiceId }));
    yield put(fetchDocsReceivedSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _fetchDocsSent(action) {
  try {
    const { userId, practiceId, providerId } = action.payload;
    yield put(showLoader(true));
    const { data } = yield call(() => chrApi('get', 'secure_share/sent_to_referrals', null, { userId, practiceId, providerId }));
    yield put(fetchDocsSentSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}
function* _postExternalContact(action) {
  try {
    yield put(showLoader(true));
    const { formData, callbackFn = () => {} } = action.payload;
    const { data } = yield call(() => chrApi('post', 'external_contact', formData, null));
    // console.log({ data });
    toast.success('Contact created Successfully');
    callbackFn();
    yield put(showLoader(false));
    yield put(postExternalContactSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

function* _putExternalContact(action) {
  try {
    yield put(showLoader(true));
    const { formData, callbackFn = () => {}, contactId } = action.payload;
    const { data } = yield call(() => chrApi('put', `external_contact/${contactId}`, formData, null));
    // console.log({ data });
    callbackFn();
    yield put(putExternalContactSuccess({ data }));
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

// TODO: Decrease count when isOpened is true
function* _putSecureShareDoc(action) {
  try {
    yield put(showLoader(true));
    const { formData, docId, callbackFn = () => {}, type, folderId, unreadCount } = action.payload;
    const { data } = yield call(() => chrApi('put', `secure_share/${docId}`, formData, null));
    yield put(putSecureShareDocSuccess({ data, type, folderId, unreadCount }));
    callbackFn();
    yield put(showLoader(false));
    // toast.success('Success');
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchExternalContactsSaga() {
  yield takeLatest(fetchExternalContacts.type, _fetchExternalContacts);
}
export function* fetchDocsReceivedSaga() {
  yield takeLatest(fetchDocsReceived.type, _fetchDocsReceived);
}
export function* fetchDocsSentSaga() {
  yield takeLatest(fetchDocsSent.type, _fetchDocsSent);
}
export function* postExternalContactSaga() {
  yield takeLatest(postExternalContact.type, _postExternalContact);
}
export function* putExternalContactSaga() {
  yield takeLatest(putExternalContact.type, _putExternalContact);
}

export function* putSecureShareDocSaga() {
  yield takeLatest(putSecureShareDoc.type, _putSecureShareDoc);
}
